import { FC } from 'react';
import styles from '../NotificationDrawer.module.scss';

interface Title {
  NO_NOTIFICATIONS: string;
  className?: string;
}

export const NoNotification: FC<Title> = ({
  NO_NOTIFICATIONS,
  className = ''
}) => {
  return (
    <span
      data-testid="no-notification"
      className={`${styles['no-notification']} d-flex u-fs--16 py-2 ${className}`}
    >
      {NO_NOTIFICATIONS}
    </span>
  );
};
